
import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { BackOrderNewFlowEditModalViewStore } from 'application/pick-ticket-new-flow/stores';
import { BackOrderNewFlowEditModalTemplate } from 'themes/application/pick-ticket-new-flow/components';

@setCurrentView((rootStore, componentProps) => new BackOrderNewFlowEditModalViewStore(rootStore, componentProps), 'backOrderNewFlowEditModalViewStore')
@observer
class BackOrderNewFlowEditModal extends React.Component {
    render() {
        return <BackOrderNewFlowEditModalTemplate {...this.props} />
    }
}

export default BackOrderNewFlowEditModal;
